import {Component, Input} from '@angular/core';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {IconPath} from '@app/shared/common/icons';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: true,
    imports: [NgClass, MatIconModule]
})
export class IconComponent {
  private classesValue: string = null;

  get classList(): string {
    return this.classesValue;
  }

  @Input() set classList(c: string) {
    this.classesValue = c;
  }

  @Input() height = 'h-5';
  @Input() width = 'w-5';

  @Input() set size(content: string) {
    this.height = `h-${content}`;
    this.width = `w-${content}`;
  }

  @Input() fontSize = '18px';
  @Input() lineHeight = '18px';
  @Input() disabled = false;

  isOldIcon = false;

  @Input() set icon(content: string | IconPath) {
    // todo remove this once the icons have been completely migrated... this is just here so that it stops large amounts of 404 errors when
    this.iconRaw = content;

    // referencing to the old set of icons
    if (!content || typeof content === 'undefined' || content.includes('mdi')) {
      this.isOldIcon = true;
      return;
    }

    // adding the icon the material icon reg.
    this.iconRegistry.addSvgIcon(
      content,
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/${content}.svg`
      )
    );
  }

  iconRaw: string = null;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
  }
}
